import restful from '../vuex'
import axios from 'axios'
import { Message, Spin } from 'view-design'

const state = {
  ...restful.states('customer'),
  customers_all: []
}

const getters = {
  ...restful.getters('customer'),
  customers_all: (state) => state.customers_all,
  aggregate_test: (state) =>
    `搜索结果：会员总剩余余额为 ${state.meta.first} 元，会员总剩余积分为 ${state.meta.second}`
}

const actions = {
  ...restful.actions('customers'),
  async start ({ commit }, id) {
    Spin.show()
    const response = await axios.post(`customers/${id}/operate`, {
      status: 'valid'
    })
    commit('updateRecordInRecords', response.data)
    Spin.hide()
    Message.success('启用成功!')
  },
  async index_all ({ commit }, params) {
    const response = await axios.get('customers', { params })
    commit('customers_all', response.data)
  },
  async stop ({ commit }, id) {
    Spin.show()
    const response = await axios.post(`customers/${id}/operate`, {
      status: 'stopped'
    })
    commit('updateRecordInRecords', response.data)
    Spin.hide()
    Message.success('停用成功!')
  }
}

const mutations = {
  ...restful.mutations('customer'),
  customers_all (state, customers_all) {
    state.customers_all = customers_all
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
